function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "checked",
  transform: "translate(-223 -47.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1078",
  "data-name": "Grupo 1078",
  transform: "translate(223 47.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_1728",
  "data-name": "Ret\\xE2ngulo 1728",
  fill: "#0055c6",
  stroke: "#0055c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 23,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 22,
  rx: 3.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1231",
  "data-name": "Caminho 1231",
  d: "M-.044-6.709,2.3-10.566H4.409L.952-5.342,4.517,0H2.427L-.015-3.955-2.456,0h-2.1L-.991-5.342l-3.457-5.225h2.09Z",
  transform: "translate(234.556 64.066)",
  fill: "#fff"
}));

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.48215c7b.svg";
export { ForwardRef as ReactComponent };